import { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  variant?: 'default' | 'accent' | 'muted'
  className?: string
}

export default function Card({ children, variant = 'default', className = '' }: CardProps) {
  const baseClasses = "rounded-card p-7 border"

  const variantClasses = {
    default: "bg-surface shadow-card border-[rgba(27,33,54,0.06)]",
    accent: "bg-[#202534] text-[#f3f6ff] border-transparent",
    muted: "bg-surface-muted border-[rgba(27,33,54,0.05)] shadow-none"
  }

  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`}>
      {children}
    </div>
  )
}
